import { takeLatest, put, call } from 'redux-saga/effects';
import axios from 'app/services/http/axios';
import { toast } from 'react-toastify';

// -------

import { Api } from 'modules/Admin/Profile'
import { Actions } from './slice'

// -------

function* get() {

  try {
    const route = Api.user;
    const response = yield call(axios.get, route);
    yield put(Actions.getProfileSuccess(response));

  } catch (e) {
    return yield put(Actions.getProfileFailed(e));
  }
}

function* save({ payload }) {

  try {
    const route = Api.profile;
    const response = yield call(axios.post, route, { ...payload });
    yield put(Actions.saveProfileSuccess(response));

    toast.success('Profile successfully updated')

  } catch (e) {
    return yield put(Actions.saveProfileFailed(e));
  }
}

// -------

export function* watchProfileSaga() {
  yield takeLatest(Actions.getProfile.type, get)
  yield takeLatest(Actions.saveProfile.type, save)
}

export default watchProfileSaga
